/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'

import { Result, Set } from '@blade/std-lib'
import { WalletId } from '@root/entities/wallet/model'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { isTauriAtom } from '@root/shared'
import { atomWithPrev, reatomResource } from '@root/shared/lib'

export const deviceWalletsStateAtom = reatomResource(async (ctx) => {
  const { secureStorageService } = ctx.get(dependenciesAtom)

  // Only the desktop application holds keys on the machine it runs on. A
  // browser has none — not even in browser-local mode, which is the same
  // browser — and asking it produces a call that never answers, which is
  // how the wallet list stayed empty while the server had wallets to show.
  if (!ctx.get(isTauriAtom)) {
    return Result.succeed([])
  }

  return ctx.schedule(() => secureStorageService.getWallets())
})

export const deviceWalletsAtom = atom((ctx) => {
  return ctx.spy(deviceWalletsStateAtom).value ?? []
})

export const deviceWalletIdsAtom = atomWithPrev<Set<WalletId>>(
  (ctx, prevIds) => {
    const wallets = ctx.spy(deviceWalletsAtom)
    const walletIds = Set.create(wallets.map((it) => WalletId(it.walletId)))
    if (prevIds && Set.equals(prevIds, walletIds)) {
      return prevIds
    }
    return walletIds
  },
  'walletIdsAtom',
)

export const loadDeviceWalletsAction = action((ctx) => {
  deviceWalletsStateAtom.run(ctx)
})
export const refreshDeviceWalletsAction = action((ctx) => {
  deviceWalletsStateAtom.refresh(ctx)
})
